import { HouseRental } from "@/types/house-rental.type";
import { formatDateTimeAutoToString } from "@/utils/format";
import { ColumnDef } from "@tanstack/react-table";
import _ from "lodash";
import { useTranslation } from "react-i18next";

export default function TableExpiredHeader(): ColumnDef<HouseRental>[] {
    const {t} = useTranslation();

    return [
        {
            header: t("house_rental.business_unit"),
            accessorKey: "business_unit.name",
            enableSorting: false
        },
        {
            header: t("house_rental.ta_end"),
            accessorKey: "ta_end",
            enableSorting: false,
            cell: ({ row }) => formatDateTimeAutoToString(row.original.ta_end ?? '', "ll")
        }
    ]
}
